import { NAME } from '../constants';

export const getHistoryState = state => state[NAME];
